import React from "react";
import { motion } from "framer-motion";
import mall from "../assets/images/mall.jpg";
import realstate from "../assets/images/realstate.jpg";
import industry from "../assets/images/industry.jpg";
import hospital from "../assets/images/hospital.jpg";
import education from "../assets/images/education.jpg";
import office from "../assets/images/office.jpg";
import LazyImage from "./LazyImage";

const industriesData = [
    {
        title: "Shopping malls",
        image: mall,
        description:
            "Comprehensive facility management for shopping centers, including cleaning, maintenance, and security services.",
    },
    {
        title: "Real estate",
        image: realstate,
        description:
            "Professional property management services for residential and commercial real estate developments.",
    },
    {
        title: "Industrial",
        image: industry,
        description:
            "Specialized facility management for industrial complexes, factories, and manufacturing plants.",
    },
    {
        title: "Hospital",
        image: hospital,
        description:
            "Healthcare facility management ensuring clean, safe, and efficient environments for patients and staff.",
    },
    {
        title: "Education",
        image: education,
        description:
            "Complete facility solutions for schools, universities, and educational institutions.",
    },
    {
        title: "Office complexes",
        image: office,
        description:
            "Full-service facility management for corporate offices and commercial buildings.",
    },
];

const Industries = () => {
    return (
        <section className="py-16 bg-gray-50">
            <div className="container mx-auto px-4">
                <motion.h2
                    initial={{ opacity: 10, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    className="text-3xl font-bold text-center mb-12"
                >
                    Industries We Serve
                    <div className="w-24 h-0.5 bg-[#FFD700] mx-auto mt-4"></div>
                </motion.h2>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
                    {industriesData.map((industry, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 10, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.02 }}
                            className="bg-white rounded-lg shadow-lg overflow-hidden"
                        >
                            <div className="h-48 overflow-hidden">
                                <LazyImage
                                    src={industry.image}
                                    alt={industry.title}
                                    className="w-full h-full object-cover transform hover:scale-110 transition-transform duration-300"
                                    width={768}
                                    height={192}
                                />
                            </div>
                            <div className="p-6">
                                <h3 className="text-xl font-bold mb-3">
                                    {industry.title}
                                </h3>
                                <p className="text-gray-600">
                                    {industry.description}
                                </p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Industries;
